import React from 'react';
import { Checkbox } from '@teetsh/app/src/components/Form/Checkboxes/Checkbox';

interface Props {
  value: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  name: string;
}

export function BoolCustomField(props: Props) {
  const { value, onChange, label, name } = props;
  return (
    <Checkbox
      id={name}
      label={label}
      checked={value}
      onChange={() => onChange(!value)}
    />
  );
}
